import { useSelector } from 'react-redux';
import { CASE_TYPE_DEMANDS, DEMAND, getDemandText } from '@demandproai/shared';
import Constants from '../../../Constants';
import XModal from '../../../components/common/XModal';
import XSelect from '../../../components/common/XSelect';
import { useTemplateContext } from '../context/TemplateContext';
import { useProductContext } from '../../../contexts/ProductContext';
import TemplateFileUpload from '../components/TemplateFileUpload';
import useCaseTypeOptions from '../../../hooks/useCaseTypeOptions';
import useUploadTemplateForm from '../hooks/useUploadTemplateForm';

const formWrapperClasses = 'grid grid-cols-1 gap-y-4';

const TemplateModal = () => {
    const { formik } = useUploadTemplateForm();
    const {
        modalOpen,
        setModalOpen,
        selectedTemplate,
        onTemplateFileUpload,
        removeTemplateDocFile,
        templateDocFile,
    } = useTemplateContext();
    const { CASE_TYPE_DEMANDS_MT } = useProductContext();
    const resolvedCaseTypeOptions = useCaseTypeOptions();
    const { demandNameMap } = useSelector((state) => state.demandMap);

    if (!modalOpen || !selectedTemplate) return null;

    const resolvedDemands = CASE_TYPE_DEMANDS_MT || CASE_TYPE_DEMANDS;

    const demandOptions = (resolvedDemands?.[formik.values.caseType] ?? [])
        .filter((v) => v !== DEMAND.Medical_Chronology)
        .map((v) => ({
            value: v,
            text: getDemandText({
                state: formik.values.state,
                caseType: formik.values.caseType,
                value: v,
                demandNameMap,
            }),
        }));

    return (
        <XModal
            isOpen={true}
            title="Upload Template"
            onClose={() => setModalOpen(false)}
            onSubmit={formik.handleSubmit}
            submitText="Save Template"
            cancelText="Close"
            size="sm"
        >
            <div className={formWrapperClasses}>
                <XSelect
                    label="Case Type"
                    name="caseType"
                    value={formik.values.caseType}
                    onChange={formik.handleChange}
                    options={resolvedCaseTypeOptions}
                    emptyOption="Select Case Type"
                />

                <XSelect
                    label="Demand Type"
                    name="demandType"
                    value={formik.values.demandType}
                    onChange={formik.handleChange}
                    options={demandOptions}
                    emptyOption="Select Demand Type"
                />

                <XSelect
                    label="State"
                    name="state"
                    value={formik.values.state}
                    onChange={formik.handleChange}
                    options={Constants.Dropdowns.States}
                    emptyOption="Select a State"
                />

                <TemplateFileUpload
                    onFileUpload={onTemplateFileUpload}
                    reportName="Template Document"
                    uploadButtonText="Upload Template"
                    removeFile={removeTemplateDocFile}
                    file={templateDocFile}
                />
            </div>
        </XModal>
    );
};

export default TemplateModal;
